import { CheckOutlined, DragOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { ScheduleItemEdit } from './ScheduleItemEdit';
export const SchedulePageToolbar = (props) => {
    const [visibleEdit, setVisibleEdit] = useState(false);
    const { event_id, isEditing, setIsEditing, currentPageData, schedule, pageItem, disabled } = props;
    return (React.createElement(Space, null,
        pageItem && pageItem.schedule_id != 'unassigned' &&
            React.createElement(Button, { key: "create", type: "primary", icon: React.createElement(PlusOutlined, null), onClick: () => setVisibleEdit(true), disabled: disabled }, _T('schedule.details.create')),
        currentPageData && currentPageData.length > 1 &&
            React.createElement(Button, { key: "sorting", icon: isEditing ? React.createElement(CheckOutlined, null) : React.createElement(DragOutlined, null), onClick: () => setIsEditing(!isEditing), disabled: disabled }, _T(isEditing ? 'common.done' : 'common.edit')),
        React.createElement(ScheduleItemEdit, { event_id: event_id, pageChildren: currentPageData, schedule: schedule, visible: visibleEdit, setVisible: setVisibleEdit, disabled: disabled })));
};
